// Create abstract class for all events
abstract class AmplitudeEvent {
  abstract name: string
  abstract category: string
  properties: { [key: string]: string | number | boolean }

  constructor(properties: { [key: string]: string | number | boolean } = {}) {
    this.properties = properties
  }
}

export default AmplitudeEvent
